// src/App.js
import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { useLocation } from "react-router-dom";
import { ThemeProvider } from "@mui/material/styles";
import { theme } from "./theme";
import Signup from "./pages/Signup";
import Login from "./pages/Login";
import VerifyOtp from "./pages/VerifyOtp";
import NinVerification from "./pages/NinVerification";
import IdentityVerification from "./pages/IdentityVerification";
import Payment from "./pages/Payment";
import AddBank from "./pages/AddBank";
import CreateGroup from "./pages/CreateGroup";
import Insurance from "./pages/Insurance";
import OnboardingStepper from "./components/OnboardingStepper";
import ProtectedRoute from "./components/ProtectedRoute";
import { ROLES } from "./auth/roles";
import RoleDashboard from "./pages/RoleDashboard";
import StartedGroups from "./pages/StartedGroups";
import GroupMembers from "./pages/GroupMembers";
import AllGroups from "./pages/AllGroups";
import JoinedGroups from "./pages/JoinedGroups";
import StartContribution from "./pages/StartedContribution";

const onboardingPaths = [
  "/signup",
  "/verify-otp",
  "/nin-verification",
  "/identity-verification",
  "/payment",
  "/add-bank",
];

function AppRoutes() {
  const location = useLocation();
  const isOnboarding = onboardingPaths.includes(location.pathname);

  return (
    <>
      {isOnboarding && <OnboardingStepper activePath={location.pathname} />}
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/verify-otp" element={<VerifyOtp />} />
        <Route path="/nin-verification" element={<NinVerification />} />
        <Route
          path="/identity-verification"
          element={<IdentityVerification />}
        />
        <Route path="/payment" element={<Payment />} />
        <Route path="/payment/success" element={<Payment />} />
        <Route path="/add-bank" element={<AddBank />} />
        <Route element={<ProtectedRoute />}>
          <Route path="/home" element={<RoleDashboard />} />
          <Route path="/insurance" element={<Insurance />} />
          <Route element={<ProtectedRoute roles={[ROLES.ADMIN]} />}>
            <Route path="/create-group" element={<CreateGroup />} />
            <Route path="/started-groups" element={<StartedGroups />} />
            <Route path="/group-request" element={<GroupMembers />} />
            <Route
              path="/started-contribution"
              element={<StartContribution />}
            />
          </Route>
          <Route element={<ProtectedRoute roles={[ROLES.MEMBER]} />}>
            <Route path="/all-groups" element={<AllGroups />} />
            <Route path="/joined-groups" element={<JoinedGroups />} />
          </Route>
        </Route>
        <Route path="*" element={<Navigate to="/home" replace />} />
      </Routes>
    </>
  );
}

function App() {
  return (
    <ThemeProvider theme={theme}>
      <Router>
        <div style={{ backgroundColor: "#52057b", minHeight: "100vh" }}>
          <AppRoutes />
        </div>
      </Router>
    </ThemeProvider>
  );
}

export default App;
